/* AQ — Origine d'un produit, 2026-09-16.

   La mention « Fabriqué au Québec » est rendue par snippets/aq-origine.liquid
   sous la ligne d'identité de la carte, là où le gabarit du thème la place.
   Décision de Félix : elle doit se lire sur l'image. Ce script la déplace donc
   dans le conteneur d'image de la carte, où assets/aq-origine.css la pose en
   haut à gauche, en badge de verre.

   Pourquoi un déplacement et pas une position en CSS : le bloc de détails de
   la carte est le repère de positionnement des échantillons de couleur du
   thème. Y toucher sortait les échantillons de leur place et cassait leur
   survol. Le thème n'est pas modifié, la carte native garde tous ses
   comportements, seule la mention change de parent.

   Les cartes qui arrivent après le chargement (défilement infini, changement
   d'onglet sur l'accueil, rendu de section) sont traitées par l'observateur. */
(function () {
  function place(root) {
    var tags = (root || document).querySelectorAll('.product-card .aq-origine');
    for (var i = 0; i < tags.length; i++) {
      var tag = tags[i];
      var card = tag.closest('.product-card');
      if (!card) continue;
      var media = card.querySelector('.product-card__images-wrapper');
      if (!media || tag.parentElement === media) continue;
      media.appendChild(tag);
    }
  }

  function boot() {
    place(document);
    if (!('MutationObserver' in window)) return;
    new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var added = mutations[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          var node = added[j];
          if (node.nodeType !== 1) continue;
          if (node.querySelector && node.querySelector('.aq-origine')) place(node);
          else if (node.classList && node.classList.contains('aq-origine')) place(node.parentElement);
        }
      }
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
